import * as yup from 'yup';

const validationSchema = yup.object({
    photoAadhar: null,
    photoBirth: null,
    photoFatherAadhar: null,
    photoMotherAadhar: null,
  });

  export default validationSchema;